import { useNavigate } from 'react-router-dom';

import { ComponentTypeForm } from '../components/ComponentTypeForm';

export const CreateComponentsComponentTypePage = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10">
      <div>
        <ComponentTypeForm
          type="Create"
          onSubmit={(componentTypeId) => {
            navigate(`/components/new?componentTypeId=${componentTypeId}`);
          }}
          onCancel={() => {
            navigate(`/components/new`);
          }}
        />
      </div>
    </div>
  );
};
